import { types, getParent } from "mobx-state-tree"

export const UsesBluebicStorePattern = types
    .model({})
    .views(self => ({
        get bluebic() {
            return getParent(self)
        },
    }))